// Mirrors recommendation/src/utils/ip/constants.ts.
// eslint-disable-next-line import/prefer-default-export
export const IP_RULES_MAX_DISTINCT_IPS = 30;
